module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Spara":"Save","Avbryt":"Cancel"},"sv":{"Spara":"Spara","Avbryt":"Avbryt"}}')
  delete Component.options._Ctor
}
